<template>
  <f7-page ptr @ptr:refresh="getAlarms">
    <navbar :title="unit.name || 'Ny enhet'" back-link="Tillbaka"></navbar>
    <f7-toolbar top bg-color="primary">
      <f7-link style="flex-grow: 1" tab-link="#active-alarms" tab-link-active>Aktiva</f7-link>
      <f7-link style="flex-grow: 1" tab-link="#cleared-alarms">Historiska</f7-link>
    </f7-toolbar>
    <f7-tabs swipeable>
      <f7-tab id="active-alarms" tab-active>
        <f7-list media-list>
          <f7-list-item v-if="!activeAlarms.length" title="Inga aktiva larm"></f7-list-item>
          <f7-list-item v-for="alarm in activeAlarms" :key="alarm.id" :title="alarm.name" :after="alarm.createdAt | datetime"></f7-list-item>
        </f7-list>
      </f7-tab>
      <f7-tab id="cleared-alarms">
        <f7-list media-list>
          <f7-list-item v-if="!clearedAlarms.length" title="Inga historiska larm"></f7-list-item>
          <f7-list-item v-for="alarm in clearedAlarms" :key="alarm.id" :title="alarm.name" :after="alarm.createdAt | datetime"></f7-list-item>
        </f7-list>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>

<script>
import unitMixin from '../mixins/unit'

export default {
  mixins: [unitMixin],
  data() {
    return {
      activeAlarms: [],
      clearedAlarms: []
    }
  },
  computed: {
    unitId() {
      return this.$f7route.params.unitId
    },
  },
  filters: {
    datetime (date) {
      return (new Date(date)).toLocaleString()
    }
  },
  mounted() {
    this.getAlarms()
  },
  methods: {
    getAlarms(event, done) {
      const app = this.$f7
      const instance = this
      app.dialog.preloader('Laddar..')

      this.$request.json(`/api/units/${this.unitId}/alarms`, (data, status) => {
        app.dialog.close()
        if (done) done()
        if (data.alarms) {
          this.activeAlarms = data.alarms.filter(a => !!a.active)
          this.clearedAlarms = data.alarms.filter(a => !a.active)
        }
      }, (xhr, status) => {
        app.dialog.close()
        if (done) done()
        if (status === 401) {
          app.dialog.alert('Du har inte åtkomst')
        } else {
          app.dialog.alert('Något gick fel')
        }
      })
    }
  }
}
</script>
<style scoped>
  .swiper-container .tab {
    overflow-y: auto;
  }

  .toolbar-inner .tab-link.tab-link-active {
    font-weight: 600;
  }
</style>